import React, { useRef, useMemo } from "react";
import { extend, useLoader, useFrame, Object3DNode } from "@react-three/fiber";
import { TextureLoader, RepeatWrapping, PlaneGeometry, Vector3, ShaderMaterial, BufferGeometry } from "three";

import { Water } from "./CustomWater.js";

extend({ Water });

function Ocean({ animationIsPlaying, geometry }: { animationIsPlaying: boolean; geometry?: BufferGeometry }) {
	const ref = useRef<Object3DNode<Water, typeof Water>>();
	// const gl = useThree((state) => state.gl);
	const waterNormals = useLoader(TextureLoader, "/static/textures/water_normal.jpg");

	waterNormals.wrapS = waterNormals.wrapT = RepeatWrapping;
	// waterNormals.repeat.set(120, 120);

	const geom = useMemo(() => {
		const geo = new PlaneGeometry(55, 55, 512, 512);
		geo.translate(0, 7, 0);

		return geo;
	}, []);
	const config = useMemo(
		() => ({
			textureWidth: 128,
			textureHeight: 128,
			waterNormals,
			sunDirection: new Vector3(),
			sunColor: 0xeb8934, //
			waterColor: 0x000000,
			distortionScale: 40,
			size: 15,
			fog: false,
			// format: gl.encoding,
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[waterNormals]
	);

	useFrame((state, delta) => {
		if (animationIsPlaying && ref?.current?.material) {
			const material = ref?.current?.material as ShaderMaterial;
			material.uniforms.time.value += delta * 1;
		}
	});

	return <water ref={ref} args={[geometry ? geometry : geom, config]} rotation-x={-Math.PI / 2} position={[0, 0, 0]} />;
}

export default Ocean;
